<template>
  <v-card
    class="card"
    tile
    elevation="0"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '712px'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <div class="pt-12 text-container">
      <section 
        :class="['d-flex flex flex-wrap', {'px-4': !$vuetify.breakpoint.mdAndUp}]" 
        style="max-width: 1340px"
      >
        <div 
          :class="[
            'd-flex',
            {'justify-start': settings.title.alignment === 'left'}, 
            {'justify-center': settings.title.alignment === 'center' || !settings.title.alignment}, 
            {'justify-end': settings.title.alignment === 'right'}
          ]" 
          style="width: 100%; text-align: center"
        >
          <h1
            class="mb-3"
            :style="
              `
              font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
              font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
              color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
              line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
              font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
              font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
              `
            "
          >
            {{ settings.title.content }}
          </h1>  
        </div>    
        
        <div 
          :class="[
            'd-flex',
            {'justify-start': settings.text.alignment === 'left'}, 
            {'justify-center': settings.text.alignment === 'center' || !settings.text.alignment}, 
            {'justify-end': settings.text.alignment === 'right'}
          ]"
          style="width: 100%; text-align: center"
        >
          <span v-html="formatedText"></span>
        </div>
      </section>
    </div>

    <div class="container pb-12">
      <v-card
        elevation="0"
        :height="$vuetify.breakpoint.mdAndUp ? '488' : '450'"
        :width="$vuetify.breakpoint.mdAndUp ? '1000' : '80%'"
      >
        <v-carousel
          cycle
          interval="3000"
          :height="$vuetify.breakpoint.mdAndUp ? '488' : '450'"
          show-arrows-on-hover
          hide-delimiters
        >
          <v-carousel-item v-for="(item, i) in settings.items" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import TitleComponent from "../title/TitleComponent.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent },
  props: {
    id: {type: String},
    settings: {
      type: Object,
    },
  },
  computed: {
    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    }
  },  

  data() {
    return {
      settingsTitle: null,
      hover: false,
    };
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.text-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-width: 1340px !important;
}
</style>